var _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle4, _path12, _rect, _rect2, _path13, _polygon, _ellipse, _ellipse2, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumerical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 923.37225,
    height: 627.61963,
    viewBox: "0 0 923.37225 627.61963",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M649.37437,427.69019H416.39317a14.03933,14.03933,0,0,1-14.02344-14.02344V311.5437a14.03933,14.03933,0,0,1,14.02344-14.02344h232.9812a14.03954,14.03954,0,0,1,14.02368,14.02344v102.123A14.03954,14.03954,0,0,1,649.37437,427.69019Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 24.00002,
    r: 17,
    fill: "#8e28f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.31382,172.19019a18,18,0,1,1,18-18A18.02039,18.02039,0,0,1,160.31382,172.19019Zm0-34a16,16,0,1,0,16,16A16.01825,16.01825,0,0,0,160.31382,138.19019Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 238.00002,
    r: 17,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M367.31382,386.19019a18,18,0,1,1,18-18A18.02031,18.02031,0,0,1,367.31382,386.19019Zm0-34a16,16,0,1,0,16,16A16.01817,16.01817,0,0,0,367.31382,352.19019Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 109.00002,
    r: 17,
    fill: "#8e28f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M499.31382,257.19019a18,18,0,1,1,18-18A18.02031,18.02031,0,0,1,499.31382,257.19019Zm0-34a16,16,0,1,0,16,16A16.01817,16.01817,0,0,0,499.31382,223.19019Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M423.53794,329.33521H190.557a14.03954,14.03954,0,0,1-14.02368-14.02344V213.18921A14.03965,14.03965,0,0,1,190.557,199.16528h232.981a14.03964,14.03964,0,0,1,14.02368,14.02393V315.31177A14.03954,14.03954,0,0,1,423.53794,329.33521Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#8e28f5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M438.73448,318.86011H205.7534a14.53993,14.53993,0,0,1-14.52356-14.52344V202.21362a14.53992,14.53992,0,0,1,14.52356-14.52343H438.73448a14.54,14.54,0,0,1,14.52368,14.52343V304.33667A14.54,14.54,0,0,1,438.73448,318.86011ZM205.7534,189.69019a12.53779,12.53779,0,0,0-12.52356,12.52343V304.33667a12.53779,12.53779,0,0,0,12.52356,12.52344H438.73448a12.5379,12.5379,0,0,0,12.52368-12.52344V202.21362a12.5379,12.5379,0,0,0-12.52368-12.52343Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M664.57066,417.21509H431.5897A14.54045,14.54045,0,0,1,417.066,402.69116V300.5686a14.54,14.54,0,0,1,14.52368-14.52343h232.981a14.54,14.54,0,0,1,14.52368,14.52343V402.69116A14.54045,14.54045,0,0,1,664.57066,417.21509ZM431.5897,288.04517A12.53789,12.53789,0,0,0,419.066,300.5686V402.69116a12.538,12.538,0,0,0,12.52368,12.52393h232.981a12.538,12.538,0,0,0,12.52368-12.52393V300.5686a12.5379,12.5379,0,0,0-12.52368-12.52343Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M810.02207,559.13013a6.50022,6.50022,0,0,1-6.47632-6.0752l-.9646-14.728a6.50019,6.50019,0,0,1,6.06128-6.91113l115.38746-7.55664a13.88,13.88,0,0,1,1.814,27.70068L810.45664,559.116Q810.23875,559.12988,810.02207,559.13013Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#8e28f5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M832.77476,561.02905a6.5084,6.5084,0,0,1-6.49268-6.25781l-.82226-21.99805a6.49952,6.49952,0,0,1,6.25293-6.73779L926.599,522.489a6.50038,6.50038,0,0,1,6.73828,6.25293l.82226,21.99805a6.49952,6.49952,0,0,1-6.25293,6.73779l-94.88623,3.54639C832.93833,561.02759,832.85606,561.02905,832.77476,561.02905Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M943.96616,763.80981H929.2064a6.50736,6.50736,0,0,1-6.5-6.5V634.29565a6.50737,6.50737,0,0,1,6.5-6.5h14.75976a6.50737,6.50737,0,0,1,6.5,6.5V757.30981A6.50736,6.50736,0,0,1,943.96616,763.80981Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M914.77378,763.80981H900.01426a6.50736,6.50736,0,0,1-6.5-6.5V634.29565a6.50737,6.50737,0,0,1,6.5-6.5h14.75952a6.50737,6.50737,0,0,1,6.5,6.5V757.30981A6.50736,6.50736,0,0,1,914.77378,763.80981Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.23535,
    cy: 312.22681,
    r: 51,
    fill: "#8e28f5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M899.11436,470.88013a12.09521,12.09521,0,0,1-5.0271-.9795,8.13345,8.13345,0,0,1-4.38013-5.28466,5.47155,5.47155,0,0,1,.89673-4.77979c1.332-1.709,3.63184-2.522,6.33789-2.314L890.244,438.77271l1.8833-.67286,7.874,22.042-1.77539-.40284c-2.05811-.46533-4.72754-.36328-6.04443,1.32666a3.51374,3.51374,0,0,0-.53272,3.06983,6.14617,6.14617,0,0,0,3.26123,3.94189c2.78345,1.25684,6.04175.80957,9.70337.146l.35645,1.96777A32.96247,32.96247,0,0,1,899.11436,470.88013Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 870.55299,
    y: 443.53894,
    width: 10.77167,
    height: 1.99975,
    transform: "translate(-210.99553 53.39222) rotate(-11.86416)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 903.82642,
    y: 436.54773,
    width: 10.77167,
    height: 1.99975,
    transform: "translate(-208.8474 60.08363) rotate(-11.86416)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M766.09785,563.01044l57.48951,31.5782a2.73775,2.73775,0,0,0,4.02547-1.18749l14.08324-29.43736a3.67453,3.67453,0,0,0-1.88346-4.41265L792.08187,534.9486a2.7868,2.7868,0,0,0-3.65211.6982l-23.842,22.46166a3.54064,3.54064,0,0,0,1.35552,4.82023Q766.0195,562.97147,766.09785,563.01044Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "631.62 422.471 685.516 453.277 699.858 427.427 653.623 402.284 631.62 422.471",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 815.67326,
    cy: 549.3244,
    rx: 0.67645,
    ry: 0.7934,
    transform: "translate(-300.86404 513.92657) rotate(-39.84152)",
    fill: "#f2f2f2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 795.66252,
    cy: 575.77022,
    rx: 0.45094,
    ry: 0.52892,
    transform: "translate(-322.45309 507.24657) rotate(-39.84152)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M964.13438,667.30054h-86a8.50951,8.50951,0,0,1-8.5-8.5l18.00415-138.06446a8.48983,8.48983,0,0,1,8.49585-8.43554h30.52a46.032,46.032,0,0,1,45.98,45.98v100.52A8.50951,8.50951,0,0,1,964.13438,667.30054Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M905.39414,511.80054l-23.25976,51,4-42.84a8.079,8.079,0,0,1,8-8.16Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M829.83677,609.655a6.51039,6.51039,0,0,1-5.94067-3.83936l-6.041-13.46679a6.49946,6.49946,0,0,1,3.27026-8.59082L926.63,536.42847a13.87944,13.87944,0,1,1,11.36182,25.32715L832.4874,609.08569A6.46379,6.46379,0,0,1,829.83677,609.655Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#8e28f5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M860.61045,602.70239A6.51006,6.51006,0,0,1,854.67,598.863l-10.3186-23.002a6.50739,6.50739,0,0,1,3.27026-8.59082L934.2562,528.406a6.49945,6.49945,0,0,1,8.59107,3.27l10.3186,23.00146a6.49946,6.49946,0,0,1-3.27026,8.59082l-86.63452,38.86475A6.47177,6.47177,0,0,1,860.61045,602.70239Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M910.23335,416.441c-8.30387-3.05879-15.12941,4.99994-22.65356,6.84488-7.19849,1.76508-14.9536-2.38742-18.79854-8.43964-4.48576-7.06093-3.37443-16.22807.70615-23.19847,4.46925-7.63431,12.42812-12.31872,20.86359-14.36486,9.66814-2.34515,19.7416-1.19178,29.28344,1.19a121.85048,121.85048,0,0,1,26.44275,9.52071c7.60964,3.93856,14.82288,9.32675,19.2704,16.78951,4.04188,6.78211,6.04135,15.22347,4.04147,22.99416a24.20529,24.20529,0,0,1-6.14522,10.62632c-3.01232,3.18865-6.46356,5.95277-9.27248,9.33511-4.2471,5.11411-7.10126,13.49557-2.91377,19.54506a9.7929,9.7929,0,0,0,3.551,3.14662c1.7103.89074,3.229-1.69732,1.51416-2.59042-3.01182-1.56859-4.105-4.75217-4.024-7.99788a16.27221,16.27221,0,0,1,3.99394-9.98206c2.94213-3.5355,6.57913-6.39776,9.68564-9.77744a27.02248,27.02248,0,0,0,6.41193-11.162c2.20758-8.0904.48125-16.90207-3.42622-24.19088-4.22845-7.88759-11.31618-13.84329-19.02962-18.17177-8.3944-4.71059-17.72388-7.86759-26.98663-10.37459-9.939-2.69-20.37557-4.20483-30.60326-2.34316-8.86578,1.61378-17.53058,5.89386-23.10616,13.13565-5.20444,6.75975-7.6906,15.97322-5.174,24.29135A22.23538,22.23538,0,0,0,880.561,426.31958a19.10108,19.10108,0,0,0,11.61383-1.515c3.89692-1.74631,7.4366-4.461,11.58117-5.62189a8.9408,8.9408,0,0,1,5.67981.15118c1.81429.66831,2.59691-2.23.79752-2.89283Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.49544,763.735h-320.294a1.19069,1.19069,0,0,1,0-2.38137h320.294a1.19068,1.19068,0,0,1,0,2.38137Z",
    transform: "translate(-138.31388 -136.19019)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumerical);
export default __webpack_public_path__ + "static/media/numerical.a1d4896d6ae4effea3ba73cb437488c2.svg";
export { ForwardRef as ReactComponent };